import PropTypes from 'prop-types';
import React from 'react';
import Switch from '../../../common/Switch';

const DoNotChargeTax = ({ checked, onChange, disabled }) => (
  <div className="layout__item u-pr">
    <Switch
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      label="Do Not Charge Tax"
    />
  </div>
);

DoNotChargeTax.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

DoNotChargeTax.defaultProps = {
  disabled: false,
};

export default DoNotChargeTax;
